import { css } from 'styled-components';

const focusOutline = css`
  outline: ${({ theme }) => `${theme.focusVisible.outlineWidth} ${theme.focusVisible.outlineStyle} ${theme.focusVisible.outlineColor}`};
  outline-offset: ${({ theme }) => theme.focusVisible.outlineOffset};
`;

export default focusOutline;
